import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { DirectivesModule } from '@app/@core/directives/directives.module';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { NgIdleModule } from '@ng-idle/core';
import { MasterdataModule } from '@pics-core/masterdata';
import { ProfileSettingsModule } from '@pics-core/profile';
import { CardiMicrostrategyModule } from '@pics-module/microstrategy';
import { CardiWorkflowModule } from '@pics-module/workflow';
import { NgxfUploaderModule } from 'ngxf-uploader';
import { ChatComponent } from './chat/chat.component';
import { DocumentUploadComponent } from './chat/document-upload/document-upload.component';
import { NewUserComponent } from './chat/new-user/new-user.component';
import { MastersComponent } from './masters/masters.component';
import { AnalyticsComponent } from './microstrategy/analytics/analytics.component';
import { QueryBuilderComponent } from './microstrategy/query-builder/query-builder.component';
import { OcrValidationModule } from './ocr-validation/ocr-validation.module';
import { PagesRoutingModule } from './pages-routing.module';
import { AnnouncementSharedModule } from '@pics-core/dynamic';

import { RbacComponent } from './rbac/rbac.component';
import { RbacModule } from './rbac/rbac.module';
import { SettingModule } from './setting/setting.module';
import { WorkflowComponent } from './workflow/workflow.component';
import { FormioModule } from '@formio/angular';
import { DocumentUploadModule } from './youth-photo/document-upload/document-upload.module';
import { ViewYouthPhotoComponent } from './youth-photo/view-youth-photo/view-youth-photo.component';
import { PageDesignerComponent } from './page-designer/page-designer.component';
import { CardiPageBuilderModule } from '@pics-core/page-builder';
import { DynamicDataComponent } from './dynamic/dynamic.component';
import { CardiDynamicModule } from '@pics-core/dynamic';
import { YouthQuickSearchModule } from './youth-quick-search/youth-quick-search.module';
import { CardyAiComponent } from './cardy-ai/cardy-ai.component';
import { CardyAiModule  } from '@pics-module/cardy-ai';
import { ElasticsearchModule } from '@pics-core/elasticsearch';
import { registerCustomGridListComponent } from './page-designer/custom-grid-list/custom-grid-list.formio';
import { 
  DxButtonModule,
  DxDataGridModule,
  DxPopupModule,
  DxTemplateModule
} from 'devextreme-angular';
import { CustomGridListComponent } from './page-designer/custom-grid-list/custom-grid-list.component';
import { registerCustomDocumentGridListComponent } from './page-designer/document-upload-grid/document-upload-grid.formio';
import { DocumentUploadGridComponent } from './page-designer/document-upload-grid/document-upload-grid.component';
import { registerSupportingDocumentGridComponent } from './page-designer/supporting-document-grid/supporting-document-grid.formio';
import { SupportingDocumentGridComponent } from './page-designer/supporting-document-grid/supporting-document-grid.component';
import { GridListModule } from './rbac/access-management/common-components/grid-list/grid-list.module';
import { PageDesignerModule } from './page-designer/page-designer.module';
import { registerCustomEducationSelectComponent } from './page-designer/custom-select/custom-select.formio';
import { registerCustomSliderComponent } from './page-designer/custom-slider/custom-slider.formio';
import { SharedModule } from '@app/shared/shared.module';
import { StripHtmlPipe } from '@app/@core/pipes/strip-html.pipe';
@NgModule({
  declarations: [
    QueryBuilderComponent,
    RbacComponent,
    AnalyticsComponent,
    NewUserComponent,
    DocumentUploadComponent,
    ChatComponent,
    WorkflowComponent,
    MastersComponent,
    ViewYouthPhotoComponent,
    PageDesignerComponent,
    DynamicDataComponent,
    CardyAiComponent,
    DocumentUploadGridComponent,
    SupportingDocumentGridComponent,
    CustomGridListComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    PagesRoutingModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    OcrValidationModule,
    CardiWorkflowModule,
    FormioModule,
    DirectivesModule,
    GridListModule,
    NgxfUploaderModule,
    MatCheckboxModule,
    MatRadioModule,
    CardiMicrostrategyModule,
    CardiPageBuilderModule,
    CardiDynamicModule,
    SettingModule,
    RbacModule,
    MasterdataModule,
    ProfileSettingsModule,
    DocumentUploadModule,
    NgIdleModule.forRoot(),
    YouthQuickSearchModule,
    CardyAiModule,
    ElasticsearchModule,
    DxDataGridModule,
    DxPopupModule,
    DxButtonModule,
    DxTemplateModule,
    PageDesignerModule,
    StripHtmlPipe,
    AnnouncementSharedModule,
  ],
  exports:[StripHtmlPipe],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class PagesModule{
    constructor(injector: Injector) {
    registerCustomGridListComponent(injector);
   // registerCustomDocumentGridListComponent(injector);
    registerSupportingDocumentGridComponent(injector);
    registerCustomEducationSelectComponent(injector);
    registerCustomSliderComponent(injector);
    }
	}
